export enum StaleDatedCheckDurationType {
  CurrentUpcomingStaleDatedChecks = 0,
  StaleDatedChecks20DaysBefore = 20,
  StaleDatedChecks30DaysAfter = 30,
  StaleDatedChecks90DaysAfter = 90,
}

export enum PayRefundStatus {
  Unknown = 0,
  RefundPending = 1,
  RefundCompleted = 2
}
export class DurationModel {
  public static defaultDurationType: StaleDatedCheckDurationType =
    StaleDatedCheckDurationType.CurrentUpcomingStaleDatedChecks;

  static types = new Map<StaleDatedCheckDurationType, DurationModel>([
    [
      StaleDatedCheckDurationType.CurrentUpcomingStaleDatedChecks,
      new DurationModel(20, 90),
    ],
    [
      StaleDatedCheckDurationType.StaleDatedChecks20DaysBefore,
      new DurationModel(20, 0),
    ],
    [
      StaleDatedCheckDurationType.StaleDatedChecks30DaysAfter,
      new DurationModel(0, 30),
    ],
    [
      StaleDatedCheckDurationType.StaleDatedChecks90DaysAfter,
      new DurationModel(0, 90),
    ],
  ]);

  constructor(public futureDays: number = 20, public pastDays: number = 90) {
    pastDays = pastDays;
    futureDays = futureDays;
  }
}
